import { useSyncExternalStore } from 'react';
import {
    AuthCircuitState,
    getCircuitState,
    subscribe,
} from 'src/utils/authCircuitBreaker';

export const useAuthCircuit = (): AuthCircuitState =>
    useSyncExternalStore(subscribe, getCircuitState, getCircuitState);
